import AvailableDataIntegration from '../model/availableDataIntegration'
import { RequestResponse, secureRequest, url } from '../utils/request-utils'

export function fetchAvailableDataIntegrations(
  companyID: string
): Promise<RequestResponse<AvailableDataIntegration[]>> {
  return secureRequest('GET', url('/v2/dataIntegrations/available', { companyID }))
}
